import { LocalOnlineGameService, type OnlineGameService, type PlayerIdentity } from "./contracts";
import type { LocalProfileStore } from "./local-profile";
import { RemoteOnlineGameService } from "./remote-online-service";

export function resolveApiBase(): string | null {
  const raw = import.meta.env.VITE_API_BASE?.trim();
  if (!raw) return null;
  return raw.replace(/\/$/, "");
}

/** Local by default; uses Worker API when VITE_API_BASE is set. */
export function createOnlineGameService(
  identity: PlayerIdentity,
  store: LocalProfileStore,
): OnlineGameService {
  const local = new LocalOnlineGameService(identity, store);
  const base = resolveApiBase();
  if (!base) return local;
  return new RemoteOnlineGameService(base, identity, local);
}
